// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"80":"user-mgt","227":"multinational","240":"direct","413":"container","794":"e-learning","921":"permission-mgt","948":"end-user"}[chunkId] || chunkId) + "." + {"80":"9ceac3a7","227":"5d43d68c","240":"627ed468","315":"f8c2b32e","413":"c6c851b1","794":"1d44a19a","921":"59d5dc25","948":"08149ccb"}[chunkId] + ".js";
};